type ReloadLocation = Pick<Location, "pathname" | "search">

export const shouldReloadForFirstServiceWorkerController = (
  location: ReloadLocation = window.location
) => {
  return !/^\/callback(?:\/|$)/i.test(location.pathname)
}
